module.exports = __webpack_public_path__ + "img/logo.df3f792e.png";